import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import useDashboardTypes from 'hooks/useDashboardTypes';

import LoadingSpinner from 'components/LoadingSpinner';
import DropdownInput from 'components/DropdownInput';
import MenuControls from 'components/Widget/components/menus/MainSettings/components/MenuControls';
import { Message } from 'components/shared';
import SORTING_OPTIONS from './sortingOptions';
import InsertDashboardMessages from '../DashboardPopupHelpers/InsertDashboardMessages';

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  },
  rootInput: {
    '& .MuiOutlinedInput-input': {
      padding: '15px 14px'
    }
  },
  modal_subtitle: {
    marginBottom: '30px'
  }
});

const InsertDashboardPopup = ({ dashboardMenuProps, handleSubmit, state, onClose }) => {
  const classes = useStyles();
  const { isLoading, isError, error } = state;

  const [type, setType] = useState('canned');
  const [value, setValue] = useState();
  const [inputValue, setInputValue] = useState('');
  const { title, description } = InsertDashboardMessages(dashboardMenuProps.operation);

  const [dropdownContentState, dashboardTypeIdValues] = useDashboardTypes(type);
  const { isLoading: isDropdownLoading } = dropdownContentState;

  const handleTypeChange = event => {
    setType(event.target.value);
    setInputValue('');
  };

  const handleValueChange = event => {
    setValue(event.target.value);

    const selectedDashboard = dashboardTypeIdValues.find(dash => dash.value === event.target.value);
    const { label } = selectedDashboard;

    setInputValue(label);
  };

  const handleInputChange = event => {
    setInputValue(event.target.value);
  };

  const onSubmit = () => {
    handleSubmit({ ...dashboardMenuProps, newDashboardId: value, name: inputValue });
  };

  return (
    <>
      <h2>{title}</h2>
      <Typography className={classes.modal_subtitle} gutterBottom>
        {description}
      </Typography>

      {isLoading && <LoadingSpinner />}
      {!isLoading && (
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="flex-start"
          spacing={3}
          className={classes.root}
        >
          <Grid item container direction="column" xs={12} md={5}>
            <h3>Dashboard type</h3>
            <DropdownInput
              selected={type}
              options={SORTING_OPTIONS}
              onSelect={handleTypeChange}
              label="Choose..."
              name="type"
            />
          </Grid>
          <Grid item container direction="column" xs={12} md={7}>
            <h3>Dashboard</h3>
            {isDropdownLoading ? (
              <LoadingSpinner />
            ) : (
              <DropdownInput
                selected={value}
                options={dashboardTypeIdValues}
                onSelect={handleValueChange}
                label="Choose..."
                name="value"
              />
            )}
          </Grid>
          {isError && (
            <Grid item xs={12}>
              <Message type="error" text={error} />;
            </Grid>
          )}
          <Grid item xs={12}>
            <h3 style={{ marginBlockStart: 0 }}>Dashboard name</h3>
            <TextField
              onChange={handleInputChange}
              value={inputValue}
              name="title"
              label="Choose"
              disabled={!value}
              variant="outlined"
              fullWidth
              classes={{
                root: classes.rootInput
              }}
            />
          </Grid>
        </Grid>
      )}

      <Box style={{ marginLeft: '-23px' }} mt={6}>
        <MenuControls
          handleClose={onClose}
          useFormSubmit={false}
          onSubmit={onSubmit}
          disabled={!value || isLoading}
        />
      </Box>
    </>
  );
};

InsertDashboardPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dashboardMenuProps: PropTypes.shape({
    operation: PropTypes.string
  }).isRequired,
  state: PropTypes.shape({
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    error: PropTypes.string,
    data: PropTypes.shape({})
  }).isRequired
};

export default InsertDashboardPopup;
